<template>
    <div class="order_history">

        <div class="order_history_header_area">
            <div class="header_action_icon" :class="{back_icon : checkBaclBtn()}" @click="eventHistoryBack()"></div>
            <div class="header_text ">
                <span>{{label['order_history_text_header']}}</span>
            </div>
            <div class="header_action_icon"></div>
        </div>

        <transition name="fadeFast" mode="in-out">
            <div class="order_history_main_area" v-if="!isDetailsClick">

                <div class="order_history_main_content_area">
                    <div class="order_history_header_div">{{label['order_history_text_header']}}</div>

                    <div class="order_history_order_mode_area">
                        <div class="order_history_order_mode_tag_div">
                            <div class="order_mode_tag" :class="{active : orderMode == 'current'}" @click="changeOrderHistoryMode('current')">
                                <div class="order_mode_innertag">{{label['order_history_order_mode_text_UpcomingEvents']}}</div>
                                <div class="order_mode_innertag_bottom_line"></div>
                            </div>
                            <div class="order_mode_tag" :class="{active : orderMode == 'pass'}" @click="changeOrderHistoryMode('pass')">
                                <div class="order_mode_innertag">{{label['order_history_order_mode_text_PastEvents']}}</div>
                                <div class="order_mode_innertag_bottom_line"></div>
                            </div>
                        </div>

                        <transition name="slide-down">
                            <div class="order_year_list_div" v-if="orderMode == 'pass'">
                                <div class="order_year_tag"
                                     v-for="(year, index) in orderYearList"
                                     :key="'y'+index"
                                     :class="{active : orderYear == year}"
                                     @click="orderYearChange(year)">
                                    {{year}}
                                </div>
                            </div>
                        </transition>
                    </div>

                    <transition name="slide-down">
                        <div class="order_history_content_div" v-if="orderList != null" :key="orderDisplayListCount">

                            <div class="order_row"
                                 v-for="(orderObj, index) in orderDisplayList"
                                 :key="'o'+index"
                                 v-if="orderDisplayList.length > 0">
                                <div class="order_list_div" @click="orderDataDetailsClick(orderObj)">

                                    <div class="image_div">
                                        <img :src="orderObj.eventImage" align="absmiddle" />
                                    </div>
                                    <div class="content_div">
                                        <div class="date_status_div">
                                            <div class="date_div">
                                                <div class="date_icon_div"></div>
                                                <div class="date_text_div">{{selectEventDateDisplay(orderObj)}}</div>
                                            </div>
                                            <!--<div class="status_div">{{orderListStatusDisplay(orderObj)}}</div>-->
                                        </div>
                                        <div class="order_no_status_div">
                                            <div class="order_no_div">{{orderObj.orderCode}}</div>
                                            <div class="status_div">{{orderListStatusDisplay(orderObj)}}</div>
                                        </div>
                                        <div class="title_div">{{orderObj.eventTitle}}</div>
                                        <div class="create_date_div">{{$root.writeDisplayDatetimeFormat2(orderObj.createDate)}}</div>
                                    </div>

                                </div>
                            </div> <!-- order_row end -->
                            <div class="order_row"
                                 v-if="orderDisplayList.length <= 0">
                                <div class="order_list_div" v-if="!isListPassEvent">
                                    {{label['order_history_order_list_no_orders']}}
                                </div>
                                <div class="order_list_div" v-if="isListPassEvent">
                                    {{label['order_history_order_list_no_orders_past']}}
                                </div>
                            </div>

                        </div>
                        <!-- order_history_content_div end -->
                    </transition>

                </div>
                <!--order_history_content_div end -->

            </div>
        </transition>
        <!-- checkout_main_area end isDetailsClick == false -->

        <transition name="fadeFast" mode="out-in">
            <router-view class="order_data_details"></router-view>
        </transition>
        <!-- isDetailsClick == true -->

    </div>
</template>

<script>

    export default {
        data() {
            return {
                orderMode: "current",
                orderYear: 0,
                orderYearList: [],
                orderList: null,
                orderDisplayList: [],
                orderDisplayListCount: 0,
                isDetailsClick: false,

            };
        },
        computed: {
            info() {
                return this.$root.info;
            },
            label() {
                return this.$root.getLabel();
            },
            isListPassEvent() {
                return (this.orderMode == "pass");
            }
        },
        components: {},
        created() {
            this.$root.getCurrentPathName();
            if (this.info.member != null) {

                this.info.loading = false;

                // get member order history
                if (this.orderList == null) {
                    this.GetMemberOrderYearList();
                    this.GetMemberOrderList();
                }

            }
            else {
                //this.$router.replace(`/` + this.info.lang + "/");
                this.$root.LoginBtnClick();
            }
        },
        watch: {
            '$root.info.lang': function (lang) {
                this.GetMemberOrderList();
            },
            '$root.info.member': function (member) {
                if (member == null) {
                    //this.$root.ReloadCurrentPage();
                    this.$router.push(`/` + this.info.lang + `/`);
                }
            }
        },
        methods: {
            getItemSubfix() {
                return this.$root.getItemSubfix();
            },
            selectEventDateDisplay(order) {
                return this.$root.writeDisplayDateFormat(order.eventStartDate) + (order.eventStartDate != order.eventEndDate ? " - " + this.$root.writeDisplayDateFormat(order.eventEndDate) : "")
            },
            eventHistoryBack() {
                if (this.checkBaclBtn()) {
                    this.$root.getCurrentPathName();
                    if (this.$root.info.currentPathName.indexOf("/eventhistory/") >= 0) {
                        this.$router.push(`/` + this.info.lang + `/member/eventhistory`);
                    }
                    else {
                        this.$router.push(`/` + this.info.lang + `/`);
                    }
                }
            },
            checkBaclBtn() {
                if (this.info.order_temp_info.order_device == 'web') {
                    return true;
                }
                else {
                    if (this.isDetailsClick) {
                        return true;
                    }
                    else {
                        return false;
                    }
                }
            },

            changeOrderHistoryMode(mode) {
                var app = this;
                app.orderMode = mode;

                app.orderYearChange(app.orderYear);
            },
            orderYearChange(year) {
                var app = this;

                if (app.isListPassEvent) {
                    app.orderYear = year;                    
                    app.orderDisplayList = app.orderDisplayList = $(app.orderList).filter((i, o) => o["isPass"] == app.isListPassEvent && o["createDateYear"] == app.orderYear).slice();
                    multiSort(app.orderDisplayList, { "eventStartDate": "asc" })
                    app.orderDisplayListCount++;
                }
                else {
                    app.orderDisplayList = $(app.orderList).filter((i, o) => o["isPass"] == app.isListPassEvent).slice();
                    app.orderDisplayListCount++;
                }
            },

            GetOrderStatusList() {
                this.$root.wsGetAsync(
                    "/files/order_status.json",
                    this.lang,
                    data => {
                        //console.log("GetOrderStatusList", data);
                        this.orderStatusList = data.list;
                    }
                );                
            },

            GetMemberOrderYearList() {
                var app = this;

                $.ajax({
                    type: "POST",
                    headers: { lang: app.info.lang, memberToken: app.info.member.memberToken },
                    url: app.info.wsUrl + "/Order/GetMemberOrderYearList",
                    contentType: "application/json",
                    dataType: "json",
                    success: (data) => {
                        console.log("GetMemberOrderYearList", data);

                        if (data.status == 0) {
                            app.orderYearList = data.orderYearList;
                            if (app.orderYearList.length > 0) {
                                app.orderYear = app.orderYearList[0];
                            }
                        }
                        else {
                            app.$root.alert(data.detail);
                        }

                    }
                });
            },

            GetMemberOrderList() {
                this.orderList = null;
                this.orderDisplayList = [];

                var app = this;
                app.info.loading = true;
                $.ajax({
                    type: "POST",
                    headers: { lang: app.info.lang, memberToken: app.info.member.memberToken },
                    url: app.info.wsUrl + "/Order/GetMemberOrderList",
                    contentType: "application/json",
                    dataType: "json",
                    success: (data) => {
                        console.log("GetMemberOrderList", data);

                        if (data.status == 0) {
                            app.orderList = data.orderList;

                            //app.orderDisplayList = $(app.orderList).filter((i, o) => o["isPass"] == app.isListPassEvent).slice();
                            app.changeOrderHistoryMode(app.orderMode);
                        }
                        else {

                            if (data.status == 98) {
                                app.$root.alert(data.detail);
                                app.$root.removeInfoMemberData();
                                //app.$root.ReloadCurrentPage();
                            }
                            else {
                                app.$root.alert(data.detail);
                            }
                        }

                        app.info.loading = false;
                    }
                });
            },
            
            orderDataDetailsClick(orderObj) {
                //console.log("orderObj", orderObj);
                this.isDetailsClick = true;
                this.$router.push(`/` + this.info.lang + "/member/eventhistory/" + encodeURI(orderObj.orderCode));
            },

            orderListStatusDisplay(order) {                
                return this.orderStatusDisplayChecking(order, order.orderStatus, order.eventStatus);
            },
            orderStatusDisplayChecking(order, orderStatus, eventStatus) {
                var re = orderStatus;

                switch (orderStatus) {
                    case "complete":                    
                        if (eventStatus == "cancel") {
                            re = this.label['order_history_status_text_EventCancelled'];
                        }
                        else {
                            if (order.haveNormalSession) {
                                re = this.label['order_history_status_text_Enrolled'];

                                if (order.isAtten) {
                                    re = this.label['order_history_status_text_Attended'];
                                }
                                else if (!order.isAtten && order.isPass) {
                                    re = this.label['order_history_status_text_Expired'];
                                }
                            } else {
                                re = this.label['order_history_status_text_EventCancelled'];
                            }
                        }
                        break;

                    case "payment":
                    case "pending_payment":
                    case "complete_processing":
                        re = this.label['order_history_status_text_PendingForPayment'];
                        break;

                    case "fail":
                        re = this.label['order_history_status_text_OrderCancelled'];
                        break;

                    case "cancel":
                        re = this.label['order_history_status_text_OrderCancelled'];
                        break;

                    case "admin_cancel":
                        re = this.label['order_history_status_text_OrderCancelled'];
                        break;

                    case "refund":
                        re = this.label['order_history_status_text_Refunded'];
                        break;

                    case "waiting":
                        re = this.label['order_history_status_text_WaitingList'];
                        break;

                    case "user_cancel_order":
                        re = this.label['order_history_status_text_OrderCancelled'];
                        break;


                    default:
                        break;
                }

                return re;
            }

        },
    };
</script>
